var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.contact/app/sidebar/addressbook-item/contact-sidebar-addressbook-item.pug");
module.exports = (req['default'] || req).apply(req, [])